import { render, staticRenderFns } from "./AdvInvoiceApplicationBaseForm.vue?vue&type=template&id=e684b6f4&scoped=true&"
import script from "./AdvInvoiceApplicationBaseForm.vue?vue&type=script&lang=js&"
export * from "./AdvInvoiceApplicationBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e684b6f4",
  null
  
)

export default component.exports